import { Button } from 'primereact/button';
import React, { type ReactNode, useEffect, useState } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';

interface ProtectedAppProps {
  children: ReactNode;
}

export const ProtectedApp: React.FC<ProtectedAppProps> = (props) => {
  const { children } = props;
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    if (!hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  switch (auth.activeNavigator) {
    case 'signinSilent':
      return <p className={'fixed bottom-4 right-4 text-xs text-gray-400'}>Signing you in...</p>;
    case 'signoutRedirect':
      return <p className={'fixed bottom-4 right-4 text-xs text-gray-400'}>Signing you out...</p>;
  }

  return (
    <>
      {auth.error ? (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4">
          <h1 className="text-4xl font-bold text-center">Oops. There has been problem with authentication.</h1>
          <Button className={'btn-primary'} onClick={() => auth.signinRedirect()}>
            Login
          </Button>
        </div>
      ) : auth.isLoading ? (
        <>
          <p className={'fixed bottom-4 right-4 text-xs text-gray-400'}>Authenticating...</p>
        </>
      ) : auth.isAuthenticated ? (
        children
      ) : (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4">
          <h1 className="text-4xl font-bold text-center">Welcome back. Please login to your account.</h1>
          <Button className={'btn-primary'} onClick={() => auth.signinRedirect()}>
            Login
          </Button>
        </div>
      )}
    </>
  );
};
